<div class="container">
    <mat-icon *ngIf="data.iconSvgPath" [svgIcon]="data.iconSvgPath"></mat-icon>
    <span class="message" data-cy="toast-notification-message">{{ data.message | translate }}</span>
    <ng-container *ngIf="!data?.deleteEnableUndo && !data.iconSvgPath">
        <mat-icon class="icon" data-cy="toast-notification-close-button" svgIcon="close" (click)="close()"></mat-icon>
    </ng-container>

    <ng-container *ngIf="data?.deleteEnableUndo && !data.iconSvgPath">
        <div class="button-container">
            <span class="button" (click)="close(true)">{{ 'meesage-dialog.undo' | translate }}</span>
        </div>
    </ng-container>
</div>
